// convert seconds to human readable format
export function convertTimeToHumanReadableFormat(seconds: number) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - hours * 3600) / 60);
  const formattedSeconds = seconds - hours * 3600 - minutes * 60;
  if (hours) {
    if (minutes) {
      return `${hours}h ${minutes}m`;
    } else {
      return `${hours}h`;
    }
  }
  if (minutes) {
    return `${minutes}m`;
  }
  return `${formattedSeconds}s`;
}

export const dateSuffix = (day: number) => {
  let suffix;
  if (day % 10 === 1 && day !== 11) {
    suffix = 'st';
  } else if (day % 10 === 2 && day !== 12) {
    suffix = 'nd';
  } else if (day % 10 === 3 && day !== 13) {
    suffix = 'rd';
  } else {
    suffix = 'th';
  }
  return suffix;
};
